import { get, post } from '../baseService'
import { CreateGroupModel } from 'app/models/createGroupModel'
import { AddCompanyToGroupModel } from 'app/models/addCompanyToGroupModel'
import { RemoveCompanyFromGroupModel } from 'app/models/removeCompaniesFromGroups'

const create = () => {
  const getGroups = (tenantId?: string) => {
    const url =
      tenantId == null
        ? '/config-api/group'
        : `/config-api/group?tenantId=${tenantId}`
    return get(url)
  }
  const addCompanyToGroups = (request: AddCompanyToGroupModel) =>
    post('/config-api/group/addCompany', request, false)

  const removeCompanyFromGroups = (request: RemoveCompanyFromGroupModel) =>
    post('/config-api/group/removeCompany', request, false)

  const addGroup = (companyInput: CreateGroupModel) =>
    post('/config-api/group/create', companyInput, false)

  const deleteGroups = (ids: number[], tenantId?: string) =>
    post('/config-api/group/delete', { ids, tenantId }, false)

  return {
    getGroups,
    addGroup,
    addCompanyToGroups,
    removeCompanyFromGroups,
    deleteGroups,
  }
}

export default {
  create,
}
